import useLogger from "./useLogger";

export default function useTrackUnsuccessfulODSRegistrationValidation() {
  const logger = useLogger();
  return (userObj) => {
    logger.trackEvent("Unsuccessful Registration during ODS Validation", {
      ...userObj,
    });
  };
}
